/* @flow */
import Config from 'Config';
import jstz from 'jstimezonedetect';
import Cookies from './Cookies';

const timezone = jstz.determine().name();
const offset = new Date().getTimezoneOffset() * 60; // in seconds.

export const staticHeaders = {
  // TODO(turadg) improve these headers to use Empire more
  'Remind101-Client-Type': 'Web',
  'Remind101-Client-Name': 'Dashboard',
  // must be a version number (e.g. 5.3 or v1700) or 'dev'. Else API will 500.
  'Remind101-Client-Version': Config.Environment.EMPIRE_RELEASE,
  'Remind101-Timezone-Id': timezone,
  'Remind101-Timezone-Offset': offset,
};

export const getCommonHeaders = () => {
  // TODO we'll have to provide the CSRF token for /graphql queries to work server-side
  const csrfToken = Cookies.isEnabled() ? Cookies.get('csrf_token') : null;
  const csrfHeader = csrfToken ? { 'X-CSRF-Token': csrfToken } : {};

  return Object.assign(
    {},
    staticHeaders,
    csrfHeader,
  );
};



// WEBPACK FOOTER //
// ./src/lib/requestHeaders.js